const css = `.P5A7sq__root{margin:0}.P5A7sq__ellipsize{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.P5A7sq__ellipsize:after{content:"";display:block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"root":"P5A7sq__root","ellipsize":"P5A7sq__ellipsize"};
